const enum PeopleRouteType {
    Default,
    ReportError,
    Feedback,
    Contact,
    ContactList,
    Folder,
    Search,
    CreateContact,
    Settings,
    Diagnostics,
}

export default PeopleRouteType;
